(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
     

  (function () {
    var menu = document.getElementById('mainmenu');
    var menuLink = document.getElementById('menu-link');
    var dropdown = document.getElementById('dropdown-menu');
    if (!menu || !menuLink) return;

    function setMenuState(isOpen) {
      menu.classList.toggle('active', isOpen);
      menuLink.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (dropdown) {
        dropdown.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
    }

    menuLink.addEventListener('click', function () {
      var isOpen = !menu.classList.contains('active');
      setMenuState(isOpen);
    });

    window.addEventListener('scroll', function () {
      if (menu.classList.contains('active')) {
        setMenuState(false);
      }
    }, { passive: true });

    if (dropdown) {
      dropdown.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setMenuState(false);
        });
      });
    }

    // Cierre de la barra de anuncios con persistencia durante la sesión
    var annBar = document.getElementById('announcement-bar');
    var annCloseBtn = document.getElementById('announcement-close');
    if (annBar) {
      if (sessionStorage.getItem('announcement_closed') === 'true') {
        annBar.style.display = 'none';
      } else if (annCloseBtn) {
        annCloseBtn.addEventListener('click', function () {
          annBar.style.display = 'none';
          sessionStorage.setItem('announcement_closed', 'true');
        });
      }
    }

    // Rotación de anuncios si hay múltiples bloques
    var items = document.querySelectorAll('.mainmenu__announcement-item');
    if (items.length > 1) {
      var current = 0;
      setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, 4500);
    }
  })();


  } catch(e) { console.error(e); }
})();
})();
